import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../profile';
import { useBoolState } from '../../useHook';
import { useSlideSearchRegistration } from './useSlideSearchRegistration';
/**
 * Proffit Searchの使用制限項目をクリックした際、モーダル表示を制御するuse
 * @param profile
 * @param userMode
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
const useSlideSearchLockItemModal = (profile, userMode, dispatch, unmountRef) => {
    const { plan, trialEndAt } = getProffitSearchValues(profile);
    const { email, hideCompleteModal, hideFormModal, initialValues, isShowCompleteModal, isShowFormModal, kanaRef, onSubmit: onSubmitRegistration, onSubmitOnlyNameAndPosition: onSubmitOnlyNameAndPositionRegistration, showFormModal, } = useSlideSearchRegistration.useSlideSearchRegistrationModal(profile, userMode, dispatch, unmountRef);
    // トライアル期限切れ会員向けのモーダル管理
    const { boolState: isShowPaidModal, changeFalse: hidePaidModal, changeTrue: showPaidModal, } = useBoolState(false);
    // フリープラン + トライアル未経験の場合はLPと同じ登録モーダルを表示
    // それ以外は有料メンバー登録モーダルを表示
    const onClickLockItem = isProffitSearchFreePlan(plan) && !trialEndAt ? showFormModal : showPaidModal;
    return {
        email,
        hideCompleteModal,
        hideFormModal,
        hidePaidModal,
        initialValues,
        isShowCompleteModal,
        isShowFormModal,
        isShowPaidModal,
        kanaRef,
        onClickLockItem,
        onSubmitOnlyNameAndPositionRegistration,
        onSubmitRegistration,
        showFormModal,
        showPaidModal,
    };
};
export const useSlideSearchLockItem = {
    useSlideSearchLockItemModal,
};
export default useSlideSearchLockItem;
